import PropTypes from 'prop-types';
import * as React from 'react';

import { COLORS } from 'theme';

const RefreshIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    {...props}
  >
    <path
      d="M3.04346 6.71361L7.5083 9.69017L7.02295 10.4187L6.5376 11.1462L3.70557 9.25755C3.87313 10.2415 4.2695 11.1782 4.86963 11.988C5.68469 13.0877 6.8325 13.8963 8.14209 14.2947C9.36973 14.668 10.6797 14.6628 11.9009 14.282L12.144 14.2009C13.4333 13.7413 14.5409 12.8788 15.3032 11.7419L16.7993 12.7449C15.822 14.2024 14.4016 15.3079 12.7485 15.8972L12.437 16.0007C10.8712 16.489 9.19174 16.4961 7.61768 16.0173C6.04361 15.5385 4.65223 14.5976 3.62354 13.3201L3.42334 13.0603C2.66499 12.0369 2.16103 10.8556 1.94092 9.614L0.26416 11.7097L-0.419434 11.1628L-1.10205 10.616L1.87451 6.89525L2.37549 6.26927L3.04346 6.71361ZM7.25146 0.475327C8.90458 -0.113952 10.7033 -0.156484 12.3823 0.354233C14.0614 0.865066 15.5327 1.90217 16.5776 3.31224C17.3357 4.3354 17.8382 5.51629 18.0581 6.75755L19.7358 4.66185L20.4194 5.20873L21.1021 5.7556L18.1255 9.4763L17.6245 10.1023L16.9565 9.65794L12.4917 6.68138L12.9771 5.95287L13.4624 5.22533L16.2925 7.11205C16.139 6.21267 15.7956 5.35292 15.2788 4.59349L15.1304 4.38451C14.3663 3.35343 13.3101 2.57818 12.1021 2.15697L11.8589 2.07689C10.5492 1.67847 9.14545 1.71196 7.85596 2.17162L7.6167 2.26244C6.42964 2.74006 5.41152 3.56455 4.69678 4.6306L3.20068 3.62767C4.11692 2.26107 5.42217 1.2039 6.94385 0.591538L7.25146 0.475327Z"
      fill={props.color || COLORS.black50}
    />
  </svg>
);

RefreshIcon.propTypes = {
  color: PropTypes.string,
};

export default RefreshIcon;
